// extracted by mini-css-extract-plugin
export default {"vacancy":"vacancy-module___vacancy___e1c2ac64","header":"vacancy-module___header___aab57ae1"};